import { BiError } from 'react-icons/bi'
import { overrideText } from 'ui/lib/overrides'
import { EmptyMessage } from 'ui'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import type { ConfirmationPageStdOverrides } from './types'

export const ConfirmationErrorNotFound = () => {
  const overrides = useOverridesContext<keyof ConfirmationPageStdOverrides>()

  return (
    <EmptyMessage
      icon={<BiError size={80} />}
      text={overrideText('Inget order-ID hittades', overrides?.orderIdNotFound)}
    />
  )
}

export const ConfirmationErrorUnknown = (props?: { message?: string | null }) => {
  const overrides = useOverridesContext<keyof ConfirmationPageStdOverrides>()

  return (
    <EmptyMessage
      icon={<BiError size={80} />}
      text={props?.message || overrideText('Okänt fel', overrides?.confirmationPageUnknownError)}
    />
  )
}
